import { createFileRoute } from '@tanstack/react-router';

import { AbstractSearchClaimable } from '@/module/Author/Abstract/AbstractSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract/search-claimable')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <AbstractSearchClaimable />;
}
